<div *ngIf="subjects?.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlex>
    <span class="mat-h1 hint-text py-48">{{noContentMessage}}</span>
</div> 

<div *ngIf="subjects?.length !== 0" class="subject-list">
    <subject-list-item class="clickable" *ngFor="let subject of subjects; trackBy: trackByFn" 
        [subject]="subject"
        [allowEdit]="allowEdit"
        [allowDelete]="allowDelete"
        [allowEditRelationship]="allowEditRelationship"
        [allowSelect]="allowSelect"
        [readOnly]="readOnly"
        [admin]="admin"
        (onEdit)="edit($event)" 
        (onDelete)="delete($event)" 
        (onSelect)="select($event)"
        (onChangeRelationship)="changeRelationship($event)"        >
    </subject-list-item>
</div>